import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from './component/header/Header';
import Footer from './component/footer/Footer';

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    
    const timer = setTimeout(() => {
      document.documentElement.scrollTop = 0;
      window.scrollTo(0, 0);
    }, 50);
    
    return () => clearTimeout(timer);
  }, [pathname]);
  
  return (
    <div className="site-wrapper">
      <Header />
      <main className="site-main" style={{ flex: 1 }}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;